/**
 * 小程序原生统一方法
 * @type {{request(*=): void, setStorageSync(*=): void, stopPullDownRefresh(*=): void, removeStorage(*=): void, navigateBack(*=): void, setStorage(*=): void, navigateTo(*=): void, showNavigationBarLoading(): void, removeStorageSync(*=): void, hideNavigationBarLoading(): void}}
 */
let wxBridge = {
  //在当前页面显示导航条加载动画
  showNavigationBarLoading(){
      uni.showNavigationBarLoading();
  },
  //在当前页面隐藏导航条加载动画
  hideNavigationBarLoading(){
      uni.hideNavigationBarLoading();
  },
  //关闭当前页面，跳转到应用内的某个页面。但是不允许跳转到 tabbar 页面
  redirectTo(params){
      uni.redirectTo(params);
  },
  //关闭当前页面
  navigateBack(params){
      uni.navigateBack(params);
  },
  //停止当前页面下拉刷新
  stopPullDownRefresh(params){
      uni.stopPullDownRefresh(params);
  },
  //接口请求
  request(params){
      uni.request(params);
  },
  //将数据存储在本地缓存中指定的 key 中
  setStorage(params){
      uni.setStorage(params);
  },
  //将数据存储在本地缓存中指定的 key 中-同步版本
  setStorageSync(key,value){
     uni.setStorageSync(key,value);
  },
  //从本地缓存中异步获取指定 key 的内容
  getStorage(params){
      uni.getStorage(params);
  },
  //从本地缓存中同步步获取指定 key 的内容
  getStorageSync(params){
      return uni.getStorageSync(params);
  },
  //异步获取当前storage的相关信息
  getStorageInfo(params){
      uni.getStorageInfo(params);
  },
  //同步获取当前storage的相关信息
  getStorageInfoSync(params){
      return uni.getStorageInfoSync(params);
  },
  //从本地缓存中移除指定 key
  removeStorage(params){
      uni.removeStorage(params);
  },
  //从本地缓存中移除指定 key
  clearStorage(params){
      uni.clearStorage(params);
  },
  //从本地缓存中移除指定 key-同步版本
  removeStorageSync(params){
      return uni.removeStorageSync(params);
  },
  //获取系统信息
  getSystemInfo(params){
      return uni.getSystemInfo(params);
  },
  //获取系统信息-同步版本
  getSystemInfoSync(params){
      return uni.getSystemInfoSync(params);
  },
  //显示消息提示框
  showToast(params){
    if (typeof params === 'string') {
      if(params.length <= 24){
        uni.showToast({
          title: params,
          icon: 'none'
        })
      }else{
        uni.showModal({
          content:params,
          showCancel:false,
          confirmText:'我知道了'
        })
      }
    } else {
      uni.showToast(params);
    }
  },
  //显示消息提示框--纯文本
  showTextToast(message){
    uni.showToast({
        icon: 'none',
        title: message
    });
  },
  //隐藏消息提示框
  hideToast(params){
      uni.hideToast(params);
  },
  //显示loading提示框
  showLoading(params){
      uni.showLoading(params);
  },
  //隐藏loading提示框
  hideLoading(params){
      uni.hideLoading(params);
  },
  //跳转处理
  navigateTo(params){
      uni.navigateTo(params);
  },
  //跳转tabbar页
  switchTab(params){
      uni.switchTab(params);
  },
  //显示模态对话框
  showModal(params){
      uni.showModal(params);
  },
  // 
  clearStorageSync() {
    uni.clearStorageSync()
  },
  nextTick(vm,callback) {
    // #ifdef H5
    vm.$nextTick(()=>{
      callback()
    })
    // #endif

    // #ifdef MP-WEIXIN
    wx.nextTick(callback)
    // #endif
  },
  getMenuButtonBoundingClientRect() {
    // #ifdef H5
    return {
      bottom: 56,
      height: 32,
      left: 320,
      right: 407,
      top: 24,
      width: 87,
    }
    // #endif

    return uni.getMenuButtonBoundingClientRect()
  },
  requestPayment(options) {
    return uni.requestPayment(options)
  },
  scanCode(options) {
    uni.scanCode(options);
  },
  //退出小程序
  exitMiniProgram(options) {
    uni.exitMiniProgram(options);
  },
  reLaunch(options) {
    uni.reLaunch(options);
  },
  replaceHttps(value, pic) {
    if (!value) return pic ? pic : 'https://minio.zykj.com/sxy-business-center/2025/03/03/39529dd9e90645138b7fa3d5f7945a1d.png';
    value = value.toString();
    return value.replace('http:', 'https:')
  }
}



export default wxBridge;
